import { AppDispatch, RootState } from '@src/store/store'
import { Store } from 'react-notifications-component'

import {
  addEmail,
  addPhone,
  setCurrentAddresses,
  setIsLoadingChangePhone,
  setIsLoadingChangePhoneNotification,
  setIsLoadingListAddresses,
  setIsSuccessChangePhone, setIsSuccessGameForm,
  setIsSuccessTerminationAgreements,
  setLastPayment,
  setListAddresses,
  setMessagesForUsers,
  setPhoneNotify,
  setServices,
  setSumToPay,
  setTerminationCauses, setUserId, setUserUnreadMessages,
  updateEmail,
  updatePhone,
  setPersonalData,
  setIsLoadingPersonalData,
  setIsSuccessPersonalData,
} from '@src/store/ducks/user/reducer'
import {
  PersonalDataType,
  ProfileGameData,
  SetNewEmailReq, SetNewPhoneReq, SetNewPhoneType, userApi,
} from '@src/api/user-api'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'
import { selectUserCurrentAddresses, selectUserId } from '@src/store/ducks/user/selectors'
import { getPromotions } from '@src/store/ducks/promotion/thunks'
import { fetchMe } from '@src/store/ducks/app/thunks'
import { setDataGamePage, setIsEditName } from '@src/store/ducks/app/reducer'
import { MessageType } from '@src/types/user'

export const getServices = (accountId: number, account: string) => async (dispatch: AppDispatch) => {
  try {
    const services = userApi.getServices(accountId)
    const sumToPay = userApi.getSumToPay(account)
    const lastPayment = userApi.getLastPayment(accountId)
    const result = await Promise.allSettled([services, sumToPay, lastPayment])

    if (result[0].status === 'fulfilled') {
      dispatch(setServices(result[0].value))
    } else {
      throw new Error(result[0].reason)
    }
    if (result[1].status === 'fulfilled') {
      dispatch(setSumToPay(Math.abs(result[1].value.balance)))
    }
    if (result[2].status === 'fulfilled') {
      dispatch(setLastPayment(result[2].value))
    }
    dispatch(getPromotions())
  } catch (err) {
    console.error(err)
  }
}

export const getAccounts = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch(setIsLoadingListAddresses(true))
  try {
    const result = await userApi.getAccounts()
    await dispatch(setListAddresses(result.listAddresses))
    const { user } = getState()
    if (!result.listAddresses.some((item) => item.accountId === user.currentAddresses)) {
      await dispatch(setCurrentAddresses(result.listAddresses[0].accountId))
    }
    const currentAddresses = selectUserCurrentAddresses(getState())
    if (currentAddresses) {
      dispatch(getServices(currentAddresses.accountId, currentAddresses.account))
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoadingListAddresses(false))
  }
}

export const changePhone = (data: SetNewPhoneReq) => async (dispatch: AppDispatch) => {
  try {
    if (data.type === SetNewPhoneType.NOTIFY) {
      dispatch(setIsLoadingChangePhoneNotification(true))
    } else {
      dispatch(setIsLoadingChangePhone(true))
    }
    await userApi.setNewPhone(
      { ...data, phone: data.phone.replace(/\D+/g, ''), oldPhone: data.oldPhone.replace(/\D+/g, '') },
    )
    if (data.type === SetNewPhoneType.NOTIFY) {
      dispatch(setPhoneNotify(data.phone))
      dispatch(setIsSuccessChangePhone(true))
    } else if (data.oldPhone) {
      dispatch(updatePhone({ phone: data.phone.replace(/\D+/g, ''), oldPhone: data.oldPhone.replace(/\D+/g, '') }))
    } else {
      dispatch(addPhone(data.phone.replace(/\D+/g, '')))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChangePhone(false))
    dispatch(setIsLoadingChangePhoneNotification(false))
  }
}

export const changeEmail = (data: SetNewEmailReq) => async (dispatch: AppDispatch) => {
  try {
    // dispatch(setIsLoadingChangePhone(true))
    await userApi.setNewEmail(data)

    if (data.oldEmail) {
      dispatch(updateEmail(data))
    } else {
      dispatch(addEmail(data.email))
    }
  } catch (err: any) {
    console.error(err)
  }
}
export const terminationAgreements = (account: string, accountId: number, comment: any) => async (dispatch: AppDispatch) => {
  try {
    await userApi.setTerminationAgreement(account, accountId, comment)
    dispatch(setIsSuccessTerminationAgreements(true))
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  }
}
export const removeCard = (accountId: number) => async () => {
  console.log('before await userApi.removeCard(accountId)')
  try {
    await userApi.removeCard(accountId)
    console.log('after await userApi.removeCard(accountId)')

    Store.addNotification({
      title: 'Успех!',
      message: 'Платёжная карта успешно удалена',
      type: 'success',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } catch (err: any) {
    console.error('Ошибка при удалении карты:', err)

    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data)
        ? err.response.data
        : 'Не удалось удалить карту. Попробуйте позже.',
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  }
}

export const getTerminationCauses = () => async (dispatch: AppDispatch) => {
  try {
    const terminationCauses = await userApi.getTerminationCauses()

    dispatch(setTerminationCauses(terminationCauses))
  } catch (err) {
    console.error(err)
  }
}

export const changeFio = (surName: string, firstName: string) => async (dispatch: AppDispatch) => {
  try {
    await userApi.changeFio(surName, firstName)
    dispatch(fetchMe())
    dispatch(setIsEditName(false))
  } catch (err) {
    console.error(err)
  }
}

export const setProfileField = (fieldId: number, value: string) => async () => {
  try {
    await userApi.setProfileField(fieldId, value)
  } catch (err) {
    console.error(err)
  }
}
export const currentGame = (data: ProfileGameData) => async (dispatch: AppDispatch) => {
  try {
    await userApi.setProfileGame(data)
    dispatch(setIsSuccessGameForm(true))
  } catch (err) {
    console.error(err)
  }
}
export const getCurrentGameData = () => async (dispatch: AppDispatch) => {
  try {
    const resultGameDataPage = await userApi.getProfileGameData()
    dispatch(setDataGamePage(resultGameDataPage))
  } catch (err) {
    console.error(err)
  }
}
export const getMessagesForUser = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const currentAddresses = selectUserCurrentAddresses(getState())
  if (currentAddresses && currentAddresses.account) {
    try {
      const resultMessagesForUsers = await userApi.getMessagesForUser(currentAddresses.account)
      // const www = await userApi.getMessagesForUser3(currentAddresses.account)
      // const eee = await userApi.getMessagesForUser4(currentAddresses.account)
      // console.log('wwwwwww', www)
      // console.log('eeeeee', eee)
      console.log('resultMessagesForUsers', resultMessagesForUsers)
      dispatch(setMessagesForUsers(resultMessagesForUsers.messages))
      dispatch(setUserId(resultMessagesForUsers.userId))

      if (resultMessagesForUsers.messages) {
        const countMsg = resultMessagesForUsers.messages.filter((message: MessageType) => !message.isRead).length
        dispatch(setUserUnreadMessages(countMsg))
      }
    } catch (err) {
      console.error(err)
    }
  } else {
    console.error('currentAddresses or account is undefined')
  }
}
export const updateStatusMsg = (id: number) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const currentUserId = selectUserId(getState())
  try {
    await userApi.updateMsgForUser(id, currentUserId)
  } catch (err) {
    console.error(err)
  }
}

export const fetchPersonalData = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoadingPersonalData(true))
  try {
    const data = await userApi.getPersonalData()
    dispatch(setPersonalData(data))
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: { duration: 5000 },
    })
  } finally {
    dispatch(setIsLoadingPersonalData(false))
  }
}

export const savePersonalData = (data: PersonalDataType) => async (dispatch: AppDispatch) => {
  console.log('THUNK STARTED WITH DATA:', data)
  dispatch(setIsLoadingPersonalData(true))
  try {
    console.log('ABOUT TO CALL API')
    await userApi.setPersonalData(data)
    dispatch(setIsSuccessPersonalData(true))
    dispatch(setPersonalData(data)) // Обновляем стейт новыми данными

    Store.addNotification({
      title: 'Успех!',
      message: 'Персональные данные успешно сохранены',
      type: 'success',
      insert: 'top',
      container: 'top-right',
      dismiss: { duration: 5000 },
    })
  } catch (err: any) {
    console.error('SAVE ERROR:', err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: { duration: 5000 },
    })
  } finally {
    dispatch(setIsLoadingPersonalData(false))
  }
}
